import styled from "styled-components";

const StyledModalTitle = styled.h3`
    font-weight: 800;
    font-size: 24px;
    color: #1e1e1e;
`;

const StyledModalDiv = styled.div`
    margin: 30px 0;
`;

export { StyledModalTitle, StyledModalDiv };
